import deepFreeze from '@ef-carbon/deep-freeze';
import { guidConvert } from '@ef-carbon/primitive';
function isIFormationMapOptions(init) {
    return init !== null && typeof init === 'object' && typeof init[Symbol.iterator] !== 'function';
}
export class FormationMap {
    constructor(init) {
        this.map = new Map();
        this[Symbol.toStringTag] = 'Map';
        const { data } = isIFormationMapOptions(init) ? init : { data: init };
        if (data) {
            for (const formation of data) {
                this.set(`${formation.id}`, formation);
            }
        }
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.map.enumerable = false;
        Object.defineProperties(this, descriptors);
    }
    delete(id) {
        const converted = guidConvert(id);
        return this.map.delete(converted);
    }
    set(id, formation) {
        const converted = guidConvert(id);
        deepFreeze(formation);
        this.map.set(converted, formation);
        return this;
    }
    get(id) {
        const converted = guidConvert(id);
        return this.map.get(converted);
    }
    get size() {
        return this.map.size;
    }
    clear() {
        this.map.clear();
    }
    has(id) {
        const converted = guidConvert(id);
        return this.map.has(converted);
    }
    forEach(callback, thisArg) {
        this.map.forEach(callback, thisArg);
    }
    keys() {
        return this.map.keys();
    }
    values() {
        return this.map.values();
    }
    entries() {
        return this.map.entries();
    }
    [Symbol.iterator]() {
        return this.entries();
    }
}
export { FormationMap as Map };
export default FormationMap;
//# sourceMappingURL=Map.js.map